export const colors = [
  'rgb(240, 236, 233)',
  'rgb(198, 205, 228)',
  'rgb(209, 232, 226)',
  'rgb(241, 222, 208)',
];
